import { useAtom } from '@reatom/npm-react'
import BigNumber from 'bignumber.js'
import styled from 'styled-components'

import { summaryModelAtom } from '@root/entities/summary'
import { SummaryTotal } from '@root/entities/summary/ui'
import { SummaryChart } from '@root/entities/summary/ui/summary-chart/mobile/summary-chart'
import { walletsTotalsStateAtom } from '@root/entities/wallet'

import type { ClassNameProps } from '@root/shared/react'

type Props = ClassNameProps

export const WalletsSummary: React.FC<Props> = ({ className }) => {
  const [model] = useAtom(summaryModelAtom)
  const [totalsState] = useAtom(walletsTotalsStateAtom)
  const [chartData] = useAtom(model.chartData)
  const [priceChangeState] = useAtom(model.priceChangeState)

  return (
    <Root className={className}>
      <SummaryTotal state={totalsState} />
      {chartData ? (
        <SummaryChart
          data={chartData}
          change={priceChangeState.value?.absolute ?? BigNumber(0)}
          changePercentage={priceChangeState.value?.percentage ?? 0}
        />
      ) : undefined}
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-template-columns: 1fr 116px;
`
